<div class="flex flex-wrap">
  @for (attribute of items; track trackByItem(index, attribute); let index = $index) {
    <div class="w-6"
      [class.m-t-2]="index > 1">
      @if (!(attribute.isText && attribute.isTextArea)) {
        <div class="p2"
        >{{ attribute.label }}:&nbsp;</div>
      }
      <div class="p2 col-11">{{ attribute.valuesLabels.join(', ') }}</div>
    </div>
  }
</div>
